'use client';

import { useEffect, useState, type ComponentType } from 'react';
import type { WaysToHelpContentItem } from '@jlg-website/database/types';
import { useLoadOnVisible } from '@/components/pages/use-load-on-visible';
import { WaysToHelpServer } from './server';

type WaysToHelpClientProps = {
  items: WaysToHelpContentItem[];
};

export default function LazyWaysToHelpClient({ items }: WaysToHelpClientProps) {
  const { ref, shouldLoad } = useLoadOnVisible<HTMLDivElement>();
  const [Client, setClient] = useState<ComponentType<WaysToHelpClientProps> | null>(null);

  useEffect(() => {
    if (!shouldLoad || Client) return;
    import('./client').then((module) => setClient(() => module.default));
  }, [Client, shouldLoad]);

  return <div ref={ref}>{Client ? <Client items={items} /> : <WaysToHelpServer items={items} />}</div>;
}
